export const CANCEL_DELIVERY_NOTE = {
    REQUEST: 'CANCEL_DELIVERY_NOTE.REQUEST',
    SUCCESS: 'CANCEL_DELIVERY_NOTE.SUCCESS',
    FAILED: 'CANCEL_DELIVERY_NOTE.FAILED',
};

export const BEGIN_CANCEL_DELIVERY_NOTE = "BEGIN_CANCEL_DELIVERY_NOTE";
export const END_CANCEL_DELIVERY_NOTE = "END_CANCEL_DELIVERY_NOTE";
